import { eApplicationActions } from './eApplicationActions';
import { IOrderLinkRequest } from '../interfaces/IOrderLinkRequest';

export interface ICreateOrderLinkRequest {
  type: eApplicationActions.CreateOrderLinkRequest;
  payload: IOrderLinkRequest;
}

export const createCreateOrderLinkRequestAction = (payload: IOrderLinkRequest): ICreateOrderLinkRequest => ({
  type: eApplicationActions.CreateOrderLinkRequest,
  payload,
});
